angular.module('impactx.orderconfiguration').controller('OrderConfigurationCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToastService',
    'ToolbarService',
    OrderConfigurationCtrl
]);

function OrderConfigurationCtrl($scope, dataGen, $routeParams, BackService, ToastService, ToolbarService) {
    var self = this;
    self.save = function () {
        if ($scope.data) {
            var dataToSave = $scope.data;

            //Reduce data which will be sent to server.
            dataToSave.companies = dataGen.slimDownPopup(dataToSave.companies);
            dataToSave.contracts = dataGen.slimDownPopup(dataToSave.contracts);

            return dataGen.postAsForm($scope, {data: dataToSave}, "/orderconfiguration/save").then(function () {

                BackService.back();
                ToastService.openStandardToast($scope.trns.saveSuccess);
            });
        }
    };

    self.delete = function () {
        return dataGen.postAsForm($scope, {id: $scope.data.id}, "/orderconfiguration/delete").then(function () {

            BackService.back();
            ToastService.openStandardToast($scope.trns.deleteSuccess);
        });
    };

    dataGen.getData($scope, {id: $routeParams.id}, "/orderconfiguration/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }
}